export const CONTENTFUL_ENTRIES = {
    "sv": {
        "home": "5EvpfwnTVFh2aWJCJ3935i",
        "comprar": "6YVJIBKW3yAuQWD900bodn",
        "alquilar": "FKiYFt1WKQi6STvCVIItP",
        "propietario": "74hxUKHKEOjPlLueGiwJUm",
        "vendedores": "2crDLEtIbF5gljrzP0NGsq",
        "somos": "5w7UEFhR2Sb0SkYb6tUjtc",
        "faq": "3beZc2TNlUXyHfoqlQfziF",
        "footer": "7GbLQhQA2SC5KFo1YXp9Xs",
        "market": "57Bp8xRXrpEQs1f5m2WUNN",
        "cities": "7gAQa0EsYoULb1CgV3vO3G",
        "search": "4Yqr0mCZ3ZpR0mSO9bcrgA",
        "home_presales": "",
        "headerPropi": "45j9F5RGnjTJldzCRAdHll",
        "presales_market": "5w0rE4eGUNBPqPSqjpes6",
        "calculadora": "2uTMPadlyPdB0UpUwiZJMZ",
        "navbarConfig": "6KXZJd7yDwrlL3v6uroQDs"
    },
    "gt": {
        "home": "5P6K2JBiGkmXeIzBkv6sXU",
        "comprar": "TjTifB6QXCR7ElIFSCYtb",
        "alquilar": "xdIJWY7ovOdmHHZaCfBVC",
        "propietario": "27QyQsD8C9TsKM8FX95egS",
        "vendedores": "4cGd2VkF7DzIRNXo9XDPwr",
        "somos": "4jBHL3NTUkCOILWGHqZfgb",
        "faq": "7zkhbSuIGsJgK4XR4Kncy1",
        "footer": "6gdUWDuA45IsiS51vOaUqp",
        "market": "3zayUFj0lC8bbSVtr2zb50",
        "cities": "ITx6lCThmXNhFvBrySsBF",
        "search": "67roB2WdYpeMhk552iO0Vv",
        "home_presales": "5kKHysL6bI5z1pS0pxZtO2",
        "headerPropi": "6DDSoQ9ibqF1gQsrrZFUGn",
        "presales_market": "1x6W9wEC6aiRkUKsc7llU2",
        "calculadora": "2D6f5MlB45dXUNfRdF7UTW",
        "navbarConfig": "7hPdskU8tLK7julhjzFf3D"
    },
    "pa": {
        "home": "38Zjov7kYjpvq8ItaL465X",
        "comprar": "TjTifB6QXCR7ElIFSCYtb",
        "alquilar": "xdIJWY7ovOdmHHZaCfBVC",
        "propietario": "27QyQsD8C9TsKM8FX95egS",
        "vendedores": "4cGd2VkF7DzIRNXo9XDPwr",
        "somos": "4YZY8eDDiEk95btsWrjmDT",
        "faq": "7zkhbSuIGsJgK4XR4Kncy1",
        "footer": "6gdUWDuA45IsiS51vOaUqp",
        "market": "3zayUFj0lC8bbSVtr2zb50",
        "cities": "28XE0N2iY1XNe6HvPi47Cp",
        "search": "2p0bnI0HtrQNQlpTKSlatU",
        "home_presales": "1WBPjoJmaMgelS97R2ipMb",
        "headerPropi": "5q8bTR3cM7mDald1fdJEx6",
        "presales_market": "3SFBRhqOfhYNLAJmRTzegI",
        "calculadora": "4XkFSRG7edeEbIG0u0T4ER",
        "navbarConfig": "4fz4KPELPB7iUbdWoVEAkM"
    }
}

export const countryMap: Record<string, string> = {
    sv: 'El Salvador',
    gt: 'Guatemala',
  };

  export const countryMapValidation: Record<string, string> = {
    sv: 'sv',
    gt: '',
  };